export const AD_STATUS = {
  ON_SALE: "on-sale",
  SOLD: "sold",
  UNDER_REVIEW: "under-review",
  APPROVED: "approved",
  ALL: "all",
  CLOSED: "closed",
};

export const BID_STATUS = {
  ALL: "all",
  WIN: "win",
  ACTIVE: "active",
  CLOSED: "closed",
  PAID: "paid",
};

export const DISPUTE_STATUS = {
  ALL: "all",
  NEW: "new",
  INPROGRESS: "inprogress",
  RESOLVED: "resolved",
};

export const USER_STATUS = {
  BLOCKED: "blocked",
  ACTIVE: "active",
};

export const USER_TYPE = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
  USER: "user",
};

export const CATEGORY_LOCATION = {
  HEADER: "header",
  OTHER: "other",
};

export const DASHBOARD_TYPE = {
  SELLER: "seller",
  BUYER: "buyer",
};

export const VERIFICATION_REQUEST_STATUS = {
  ALL: "all",
  NEW: "new",
  INPROGRESS: "inprogress",
  RESOLVED: "resolved",
};

export const USER_BADGE = {
  ESTABLISHED: "established",
  FOUNDING_MEMBER: "founding-member",
  VERIFIED: "verified",
};

export const DEFINED_BADGES = [
  { value: USER_BADGE.ESTABLISHED, label: "Established" },
  { value: USER_BADGE.FOUNDING_MEMBER, label: "Founding Member" },
  { value: USER_BADGE.VERIFIED, label: "Verified" },
];

export const AD_SORTING = {
  PRICE_LOW_TO_HIGH: "price-low-to-high",
  PRICE_HIGH_TO_LOW: "price-high-to-low",
  RECENT_FIRST: "recent-first",
};

export const AD_TYPES = {
  OPEN_FOR_BIDS: "open-for-bids",
  POPULAR: "popular",
  UPCOMING: "upcoming",
  COMING_SOON: "coming-soon",
  SOLD: "sold",
  ALL: "all",
  OTHERS: "others",
};

export const NOTIFICATION_STATUS = {
  READ: "read",
  UNREAD: "unread",
};

// Trustap event codes per:
// https://docs.trustap.com/docs/concepts/webhooks#webhook-event-codes
export const PAYMENT_STATUS = {
  ALL: "all",
  JOINED: "basic_tx.joined",
  PAID: "basic_tx.paid",
  PAYMENT_REVIEW_FLAGGED: "basic_tx.payment_review_flagged",
  TRACKED: "basic_tx.tracked",
  TRACKING_DEADLINE_EXTENDED:
    "basic_tx.tracking_details_submission_deadline_extended",
  DELIVERED: "basic_tx.delivered",
  COMPLAINED: "basic_tx.complained",
  COMPLAINT_PERIOD_ENDED: "basic_tx.complaint_period_ended",
  CLAIMED: "basic_tx.claimed",
  FUNDS_RELEASED: "basic_tx.funds_released",
  CANCELLED: "basic_tx.cancelled",
  FUNDS_REFUNDED: "basic_tx.funds_refunded",
  PAYMENT_FAILED: "basic_tx.payment_failed",
};

// User-facing labels for PAYMENT_STATUS values. Source of truth for both
// the filter dropdown and the row chip — raw Trustap codes like "joined"
// confuse end users.
export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  [PAYMENT_STATUS.ALL]: "All",
  [PAYMENT_STATUS.JOINED]: "Awaiting payment",
  [PAYMENT_STATUS.PAID]: "Paid",
  [PAYMENT_STATUS.PAYMENT_REVIEW_FLAGGED]: "Under review",
  [PAYMENT_STATUS.TRACKED]: "Shipped",
  [PAYMENT_STATUS.TRACKING_DEADLINE_EXTENDED]: "Shipping deadline extended",
  [PAYMENT_STATUS.DELIVERED]: "Delivered",
  [PAYMENT_STATUS.COMPLAINED]: "Complained",
  [PAYMENT_STATUS.COMPLAINT_PERIOD_ENDED]: "Complaint window ended",
  [PAYMENT_STATUS.CLAIMED]: "Claimed",
  [PAYMENT_STATUS.FUNDS_RELEASED]: "Funds released",
  [PAYMENT_STATUS.CANCELLED]: "Cancelled",
  [PAYMENT_STATUS.FUNDS_REFUNDED]: "Refunded",
  [PAYMENT_STATUS.PAYMENT_FAILED]: "Payment failed",
};

// Arta shipment status values.
export const SHIPMENT_STATUS = {
  ALL: "all",
  PENDING: "pending",
  CONFIRMED: "confirmed",
  COLLECTED: "collected",
  IN_TRANSIT: "in_transit",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const SHIPMENT_STATUS_LABELS: Record<string, string> = {
  [SHIPMENT_STATUS.ALL]: "All",
  [SHIPMENT_STATUS.PENDING]: "Pending",
  [SHIPMENT_STATUS.CONFIRMED]: "Confirmed",
  [SHIPMENT_STATUS.COLLECTED]: "Collected",
  [SHIPMENT_STATUS.IN_TRANSIT]: "In Transit",
  [SHIPMENT_STATUS.COMPLETED]: "Completed",
  [SHIPMENT_STATUS.CANCELLED]: "Cancelled",
};
